import { render } from "./CreateUserDialog.vue?vue&type=template&id=1c9a3fa4"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__